var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex column page"},[_c('div',{staticClass:"container"},[_c('v-title',{attrs:{"value":_vm.businessUserTitle}}),_c('router-view',{staticClass:"route-view"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }